const state = {
    auth: {
        isLogin: false,
        user: {}
    }
}

const getters = {
    getAuth: state => state.auth
}

const actions = {
    finalizeSignUpUser({ commit }, authObj) {
        commit('setAuth', authObj)
    },
    singOutAuth({ commit }) {
        commit('setAuthSignOut')
    }
}

const mutations = {
    setAuth(state, authObj) {
        window.localStorage.setItem('FordaysJPNSEQ', authObj.user.JPNSEQ)
        state.auth = {
            isLogin: true,
            user: authObj.user
        }
    },
    setAuthSignOut(state) {
        window.localStorage.removeItem('FordaysJPNSEQ')
        state.auth = {
            isLogin: false,
            user: {}
        }
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}